import React from 'react';
import { ArrowLeft, AlertTriangle, CheckCircle, ClipboardList } from 'lucide-react';

const SafetyPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-cyan-500/20">
        <nav className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a 
              href="/"
              className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors"
            >
              <ArrowLeft size={20} />
              <span className="text-sm">Back to Home</span>
            </a>
            <span className="text-2xl font-bold">
              <span className="text-cyan-400 neon-text">EFAM</span>
            </span>
          </div>
        </nav>
      </header>

      {/* Content */}
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-6 max-w-4xl">
          {/* Page Title */}
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-8" style={{ color: '#ff6b00' }}>
            SAFETY INFORMATION
          </h1>
          
          <p className="text-lg text-gray-400 text-center mb-12 leading-relaxed">
            EMS technology is powerful and effective - but not suitable for everyone Please read this information carefully
          </p>

          {/* NOT RECOMMENDED Section */}
          <div className="mb-10 p-8 rounded-xl" style={{ backgroundColor: 'rgba(255,107,0,0.1)', borderLeft: '5px solid #ff6b00' }}>
            <div className="flex items-center space-x-3 mb-6">
              <AlertTriangle className="text-orange-500" size={28} />
              <h2 className="text-2xl font-bold" style={{ color: '#ff6b00' }}>NOT RECOMMENDED FOR</h2>
            </div>
            
            <ul className="space-y-3 text-gray-300">
              <li><strong>Pregnancy</strong> - EMS is not recommended during pregnancy or while breastfeeding</li>
              <li><strong>Pacemakers or Implanted Devices</strong> - Electromagnetic fields may interfere with medical devices</li>
              <li><strong>Metal Implants</strong> - Surgical pins, plates, or metal joints in treatment areas</li>
              <li><strong>Heart Conditions</strong> - Cardiac arrhythmias, recent heart attack, or uncontrolled hypertension</li>
              <li><strong>Epilepsy</strong> - History of seizures or neurological conditions</li>
              <li><strong>Cancer</strong> - Active cancer or tumor presence</li>
              <li><strong>Recent Surgery</strong> - Surgical sites less than 6 months healed</li>
              <li><strong>Bleeding Disorders</strong> - Hemophilia or anticoagulant medication</li>
              <li><strong>Fever or Infection</strong> - Active fever, infection, or inflammatory conditions</li>
              <li><strong>Skin Conditions</strong> - Open wounds, severe dermatitis, or skin infections in treatment areas</li>
            </ul>
          </div>

          {/* MEDICAL CLEARANCE Section */}
          <div className="mb-10 p-8 rounded-xl" style={{ backgroundColor: 'rgba(0,212,255,0.05)', borderLeft: '5px solid #00d4ff' }}>
            <div className="flex items-center space-x-3 mb-6">
              <CheckCircle className="text-cyan-400" size={28} />
              <h2 className="text-2xl font-bold text-cyan-400">MEDICAL CLEARANCE REQUIRED</h2>
            </div>
            
            <p className="text-gray-300 mb-4">
              If you have ANY of the following conditions, you MUST consult your doctor before using EMS technology:
            </p>
            
            <ul className="space-y-3 text-gray-300">
              <li>Chronic health conditions (diabetes, autoimmune disorders, etc)</li>
              <li>Current or recent injuries requiring medical treatment</li>
              <li>Taking prescription medications</li>
              <li>Under active medical care for any condition</li>
              <li>Concerns about physical readiness for muscle stimulation</li>
            </ul>
          </div>

          {/* BEFORE FIRST SESSION Section */}
          <div className="mb-10 p-8 rounded-xl bg-slate-900">
            <div className="flex items-center space-x-3 mb-6">
              <ClipboardList className="text-white" size={28} />
              <h2 className="text-2xl font-bold text-white">Before Your First Session</h2>
            </div>
            
            <ol className="space-y-3 text-gray-300 list-decimal list-inside">
              <li><strong>Consult Your Doctor</strong> - Always get medical clearance first</li>
              <li><strong>Read the Manual</strong> - Comprehensive setup guide included with every unit</li>
              <li><strong>Start Low</strong> - Begin with lower intensity settings and gradually increase</li>
              <li><strong>Stay Hydrated</strong> - Drink plenty of water before and after sessions</li>
              <li><strong>Listen to Your Body</strong> - Stop immediately if you experience unusual pain or discomfort</li>
            </ol>
          </div>

          {/* Disclaimer */}
          <div className="text-center p-8 rounded-xl" style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}>
            <p className="text-sm text-gray-500 mb-4 leading-relaxed">
              EFAM systems are professional-grade equipment intended for use by informed individuals or under professional supervision This information does not constitute medical advice Always consult qualified healthcare professionals before beginning any new fitness, recovery, or treatment protocol
            </p>
            
            <p className="text-xs text-gray-600 mb-4">
              By purchasing and using EFAM equipment, you acknowledge that you have read, understood, and will comply with all safety guidelines and manufacturer instructions
            </p>
            
            <p className="text-sm text-gray-400">
              <strong>Questions?</strong> Contact us at efamfitness@gmail.com or 0490 792 050 (9am-5pm)
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-800 py-8">
        <div className="container mx-auto px-6 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} EASY FITNESS & MASSAGE (ABN 88 644 774 778) All rights reserved
          </p>
        </div>
      </footer>
    </div>
  );
};

export default SafetyPage;
